import RequstCognitoPublicCredentials from './RequstCognitoPublicCredentials';

export default async function InitCognitoCreds(...keys: string[]) {
    Promise.all(
        keys.map(key => {
            return RequstCognitoPublicCredentials(key);
        })
    );
}
